<template>
  <b-card
    :title="'Reportes '+new Date().getFullYear() "
  >
    <b-card-body class="pt-0 pl-0">
      <b-media no-body>
        <b-media-aside
          vertical-align="center"
          class="mr-50"
        >
          <b-avatar
            href="javascript:void(0)"
            size="24"
            :src="require('@/assets/images/portrait/small/avatar-s-16.jpg')"
          />
        </b-media-aside>
        <b-media-body>
          <small class="text-muted mr-50">to</small>
          <small>
            <b-link class="text-body">{{ userRol.nombre }}</b-link>
          </small>
          <span class="text-muted ml-75 mr-50">|</span>
          <small class="text-muted">
            <feather-icon
              icon="MessageSquareIcon"
              class="mr-50"
            />
            <span class="font-weight-bold">Los reportes se irán categorizando y extendiendo.</span></small>
        </b-media-body>
      </b-media>
      <div class="pt-1 pb-1">
        <b-link
          v-for="(tag,index) in reportes"
          :key="index"
        >
          <b-badge
            pill
            class="mr-75"
            :variant="tag.type"
            @click="goToReports(tag.rules)"
          >
            <feather-icon
              :icon="tag.icon"
              class="mr-50"
            />
            {{ tag.name }}
          </b-badge>
        </b-link>
      </div>
      <b-card-text class="blog-content-truncate">
        Los reportes de este módulo irán evolucionando y adecuándose de acuerdo con las necesidades de la SEP y de Servicios Escolares.
      </b-card-text>
      <b-card-footer class="pt-1 pb-0">
        <small class="text-muted"> Se esta preparando reportes financieros.</small>
      </b-card-footer>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BMediaBody,
  BMedia,
  BMediaAside,
  BCardText,
  BAvatar,
  BLink,
  BBadge,
  // BCardTitle,
  BCardFooter,
  // BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'
import { rolesActions } from '@core/mixins/account-data/roles'

export default {
  components: {
    BCard,
    BCardBody,
    BMediaBody,
    BCardText,
    BMedia,
    BMediaAside,
    BAvatar,
    // BCardTitle,
    BCardFooter,
    // BButton,
    BLink,
    BBadge,
    // BImg,
    // BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [rolesActions],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      reportes: [],
      answer: 'No puedo darte una respuesta hasta que hagas una pregunta!',
    }
  },
  created() {
    this.reportes = [{
      name: 'Alumnos', type: 'light-success', rules: [false, true], icon: 'UsersIcon',
    },
    {
      name: 'Aspirantes', type: 'light-info', rules: [true, false], icon: 'FlagIcon',
    },
    ]
  },
  methods: {
    kFormatter,
    aviso() {
      this.$bvToast.toast('Este modulo aun no se define en dirección.', {
        title: 'Atención',
        variant: 'info',
        solid: true,
      })
    },
    goToReports(tab) {
      // this.$router.push('/reportes')
      this.$router.push({ name: 'reportes-varios', params: { tab } })
    },
  },
}
</script>
<style scoped>
 .examplee {
    background: rgb(68,165,118);
    background: linear-gradient(45deg, rgba(68,165,118,1) 0%, rgba(9,117,121,0.99) 60%, rgba(73,52,92,1) 100%);
 }
</style>
